import styled from 'styled-components/macro'
import { COLORS } from 'design_system/colors'

export const Container = styled.div`
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  fill: ${({ $isCommunicating }) =>
    $isCommunicating ? COLORS.powin_green : COLORS.powin_red};
`
